<template>
    <video id="my-video"
           class="video-js vjs-default-skin"
           controls
           :height="height"
           :width="width">
        <source :src="videoSource"
                type="application/x-mpegURL" />
    </video>
</template>

<script>
import videojs from 'video.js'
import 'videojs-contrib-hls'
export default {
    name: 'VideoPlayer',
    data () {
        return {
            player: {}
        }
    },
    props: {
        videoDetails: {
            type: Object,
            required: true
        },
        videoVisible: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '918px'
        },
        height: {
            type: String,
            default: '516px'
        }
    },
    computed: {
        videoSource () {
            return `/ms-hoc-video/v1/video/play/${this.videoDetails.videoId}/${this.videoDetails.videoName}.m3u8`
        }
    },
    mounted () {
        this.$nextTick(() => {
            let options = {
                bigPlayButton: false,
                textTrackDisplay: false,
                posterImage: false,
                errorDisplay: false,
                controlBar: true,
                preload: 'auto', // 预加载
                language: 'zh-CN' // 初始化语言
            }

            let that = this
            videojs('my-video', options, function () {
                that.player = this
                this.play()
            })
        })
    },
    destroyed () {
        this.player.dispose()
    }
}
</script>
<style lang="scss">
</style>
